import React, { useCallback } from 'react'
import debounce from 'debounce-promise'
import { SelectAsync } from '@arnsbogroup/react-voicearchive'

const ApiSelect = ({ descriptor, value, onChange }) => {
  const loadOptions = useCallback(
    debounce((inputValue) => {
      const url = new URL(descriptor.optionsUrl, window.location.origin)
      if (inputValue) {
        url.searchParams.set(`search[${descriptor.searchKey}]`, inputValue)
      }
      return fetch(url.pathname + url.search, { credentials: 'same-origin' })
        .then(r => r.json())
        .then(items => (items || []).map(item => ({
          value: item[descriptor.valueKey],
          label: item[descriptor.labelKey],
        })))
    }, 250),
    [descriptor.optionsUrl, descriptor.valueKey, descriptor.labelKey]
  )

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">{descriptor.label}</label>
      <SelectAsync
        isClearable
        cacheOptions
        defaultOptions
        loadOptions={loadOptions}
        value={value ?? null}
        onChange={opt => onChange(descriptor.key, opt ?? null)}
        placeholder={`All ${descriptor.label.toLowerCase()}...`}
        noOptionsMessage={({ inputValue }) => inputValue ? `No results for '${inputValue}'` : 'No results'}
        loadingMessage={() => 'Loading...'}
      />
    </div>
  )
}

export default ApiSelect
